module.exports = __webpack_public_path__ + "static/media/calendar-green.f03542bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/calendar-green.svg
// module id = 2758
// module chunks = 0